import { EPersonalityTypes } from 'affiny-core/modules/personalityReport/types';
import React, { SVGAttributes } from 'react';
import { ISvgProps } from './svg.types';
import * as icons from './svgr';

export type IconName = keyof typeof icons;

interface ISvgTypeProps extends SVGAttributes<SVGSVGElement> {
  type: IconName;
}

export const Svg = ({ type, ...otherProps }: ISvgTypeProps) => {
  const Component = icons[type];

  return Component ? <Component {...(otherProps as ISvgProps)} /> : null;
};

const BASE_WIDTH = 138;
const BASE_HEIGHT = 122;

interface ISvgPersonalityReportProps {
  personalityType?: EPersonalityTypes;
  ratio?: number;
}

export const SvgPersonalityReport = ({
  personalityType,
  ratio = 2,
}: ISvgPersonalityReportProps) => {
  switch (personalityType) {
    case EPersonalityTypes.CHIVALROUS:
      return (
        <icons.PersonalityReportChevaleresque
          width={BASE_WIDTH * ratio}
          height={BASE_HEIGHT * ratio}
        />
      );
    case EPersonalityTypes.EGALITARIAN:
      return (
        <icons.PersonalityReportEgalitaire
          width={BASE_WIDTH * ratio}
          height={BASE_HEIGHT * ratio}
        />
      );
    case EPersonalityTypes.NEO_ROMANTIC:
      return (
        <icons.PersonalityReportNeoromantique
          width={BASE_WIDTH * ratio}
          height={BASE_HEIGHT * ratio}
        />
      );
    case EPersonalityTypes.TRADITIONNALIST:
      return (
        <icons.PersonalityReportTraditionnel
          width={BASE_WIDTH * ratio}
          height={BASE_HEIGHT * ratio}
        />
      );
    default:
      return null;
  }
};
